import { render, staticRenderFns } from "./modal-benefit.vue?vue&type=template&id=9379d4e2&"
import script from "./modal-benefit.vue?vue&type=script&lang=js&"
export * from "./modal-benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports